import axios from "axios";
export const homeService = {
    getFilesBucketsStates,
    getWedgetData
};

var qs = require("qs");

function getFilesBucketsStates(params) {
    return axios
        .get("Tracking/getfilesbucketsstatsfull", {
            params: params,
            paramsSerializer: function(params) {
                return qs.stringify(params, { arrayFormat: "repeat" });
            }
        })
        .then(handleResponse)
        .catch(error => {
            return Promise.reject(error);
        });
}

function getWedgetData(params) {
    return axios
        .get("Dashboard/DashboardData", {
            params: params,
            paramsSerializer: function(params) {
                return qs.stringify(params, { arrayFormat: "repeat" });
            }
        })
        .then(handleResponse)
        .catch(error => {
            return Promise.reject(error);
        });
}

function handleResponse(response) {
    if (response.data.Errors && response.data.Errors.length > 0) {
        // TODO handle error
        return Promise.reject(response.data.Errors[0]);
    }
    return Promise.resolve(response.data);
}